/* ============================================================
   VENTURE SOCKS — CART DRAWER LOGIC
   ============================================================
   Talks to Shopify's built-in AJAX Cart API (/cart.js,
   /cart/add.js, /cart/change.js) so it works regardless of
   how the rest of your theme is built.

   ---------------------------------------------------------
   EDIT THIS CONFIG BLOCK — everything you need to tune lives
   here. No need to touch anything below it.
   ---------------------------------------------------------
*/

/* ============================================================
   FREE SHIPPING THRESHOLDS — auto-derived per country, live
   ============================================================
   This matches your real Shopify shipping zones (Settings →
   Shipping and delivery) as of the last time someone checked:
     - Domestic (United Kingdom):                          £40
     - "Rest of world" zone (Europe — see country list       £64
       below):
     - "UAE,Africa SOUTH AMERICA, OCEANIA" zone (everything  £100
       else — this also covers the US/Canada, despite the
       zone's name):

   Shopify has no way to hand these GBP amounts to a theme
   automatically — configured shipping-zone rates only exist in
   Admin → Settings → Shipping and delivery, which only the Admin
   API can read, and that API needs a private access token that
   can never safely live in a public theme file. So the THREE
   NUMBERS BELOW are the one thing to update by hand, and only
   when you actually change a rate in Admin — everything else on
   this page (which country gets which number, and what it looks
   like in the shopper's own currency) is fully automatic:

   - `window.Shopify.country` (set by Shopify on every storefront
     page for Markets-enabled shops) tells us the shopper's
     resolved country, which decides which of the three GBP
     numbers above applies.
   - `window.Shopify.currency.rate` (also set by Shopify) is a
     LIVE exchange rate from your shop's base currency (GBP) to
     whatever currency that shopper is seeing prices in — same
     rate Shopify itself uses to convert your product prices. No
     API key, no server, no manual per-currency table to maintain.

   If you ever add/move a country between shipping zones in
   Admin, update VENTURE_EUROPE_ZONE_COUNTRIES below to match.
   ============================================================ */
var VENTURE_EUROPE_ZONE_COUNTRIES = [
  "AX", "AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CZ", "DK", "EE",
  "FO", "FI", "FR", "DE", "GI", "GR", "GG", "HU", "IS", "IE", "IM", "IT",
  "JE", "XK", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL", "MK",
  "NO", "PL", "PT", "RO", "RU", "SM", "RS", "SK", "SI", "ES", "SJ", "SE",
  "CH", "UA", "CY"
];

var VENTURE_SHIPPING_ZONE_GBP = {
  domestic: 40,
  europe: 64,
  restOfWorld: 100
};

function ventureFreeShippingThresholdGBP() {
  var country = window.Shopify && window.Shopify.country;
  if (country === "GB") return VENTURE_SHIPPING_ZONE_GBP.domestic;
  if (country && VENTURE_EUROPE_ZONE_COUNTRIES.indexOf(country) !== -1) return VENTURE_SHIPPING_ZONE_GBP.europe;
  return VENTURE_SHIPPING_ZONE_GBP.restOfWorld;
}

function ventureLiveFxRate() {
  var rate = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
  return rate && !isNaN(rate) ? rate : 1;
}

// Fallback only for the rare case window.Shopify isn't present at all
// (e.g. this file loaded outside a normal Shopify storefront page).
window.VentureFreeShippingThresholds = {
  GBP: 40,
  USD: 75,
  EUR: 75,
  default: 75
};

window.VentureCartConfig = window.VentureCartConfig || {

  // ---- REWARD BARS ------------------------------------------------
  // Add, remove, or reorder tiers freely — the drawer renders
  // whatever's in this array, in order. Each entry needs a
  // unique "id".
  rewards: [

    {
      id: "free-shipping",
      type: "spend_threshold",
      label: "Free Shipping",
      // Simple line icon (not emoji) to match your monochrome cart —
      // swap for any inline SVG you like.
      icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4h13v11H1zM14 8h4l4 4v3h-8zM4.5 19.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17.5 19.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>',

      // The live threshold is computed automatically per-country/currency
      // (see VENTURE_SHIPPING_ZONE_GBP and VENTURE_EUROPE_ZONE_COUNTRIES
      // at the very top of this file — that's the one place to edit the
      // three GBP numbers if a real Shopify shipping rate changes).
      // This static table is only a fallback for the rare case
      // window.Shopify isn't available on the page.
      thresholds: window.VentureFreeShippingThresholds,

      lockedMessage: "You're {remaining} away from <strong>FREE shipping</strong>",
      unlockedMessage: "Nice one — you've unlocked <strong>FREE shipping</strong>"
    },

    {
      id: "bogo",
      type: "bogo_quantity",
      label: "Buy 3 Get 1 Free",
      icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 9h18v11H3zM3 9V6a2 2 0 012-2h14a2 2 0 012 2v3M12 4v16M8 9c0-2.2-1.5-4-3-4M16 9c0-2.2 1.5-4 3-4" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" stroke-linecap="round"/></svg>',

      // How many items make one "bundle" (3 paid + 1 free = 4).
      bundleSize: 4,

      // Product types to EXCLUDE from the count, e.g. if the
      // promo is socks-only. Leave empty to count every item.
      // Example: excludeProductTypes: ["Coffee", "Accessories", "Gift Card"]
      excludeProductTypes: [],

      lockedMessage: "Add {remaining} more pair(s) — 1 of your 4 is <strong>FREE</strong>",
      unlockedMessage: "You've unlocked <strong>{count} free pair(s)</strong> — nice"
    }

    // Add another tier any time, e.g.:
    // {
    //   id: "free-gift",
    //   type: "spend_threshold",
    //   label: "Free Gift",
    //   icon: "✨",
    //   thresholds: { GBP: 90, USD: 120, EUR: 100, default: 90 },
    //   lockedMessage: "Spend {remaining} more for a free gift",
    //   unlockedMessage: "Your free gift is unlocked!"
    // }
  ],

  // Selector(s) that open the drawer. The script also always
  // listens for [data-vcd-open] and .vcd-open-trigger.
  openTriggerSelectors: ["[data-vcd-open]", ".vcd-open-trigger"],

  // Auto-open the drawer whenever something is added to cart.
  autoOpenOnAdd: true,

  // ---- PRODUCT RECOMMENDATIONS / UPSELL ---------------------------
  upsell: {
    enabled: true,
    label: "You need these too",
    buttonText: "Add",
    maxProducts: 3
    // Pulls from window.VentureCartBestSellers, a static list rendered
    // by venture-cart-drawer.liquid from a Shopify collection — set
    // that collection's sort order to "Best selling" in Admin
    // (Products → Collections → your collection → Sort → Best selling).
    // Items already in the cart are always filtered out client-side.
  },

  // ---- TRUST BADGES ------------------------------------------------
  trustBadges: {
    enabled: true,
    // Add your own payment icon image paths here, e.g. using Shopify
    // asset URLs once uploaded: "{{ 'visa.svg' | asset_url }}".
    // Left empty by default so nothing broken renders until you do.
    icons: []
    // icons: [
    //   { src: "https://cdn.shopify.com/.../visa.svg", alt: "Visa" },
    //   { src: "https://cdn.shopify.com/.../paypal.svg", alt: "PayPal" }
    // ]
  }
};

// Picks up the real, theme-hosted icon URLs set by venture-cart-drawer.liquid
// (asset_url only works inside .liquid files, not here). If that inline
// script didn't run for some reason, this quietly falls back to the
// empty array above and the trust badge row just stays hidden.
if (window.VentureCartTrustBadgeIcons && window.VentureCartTrustBadgeIcons.length) {
  window.VentureCartConfig.trustBadges.icons = window.VentureCartTrustBadgeIcons;
}


(function () {
  "use strict";

  var CONFIG = window.VentureCartConfig;
  var root = document.getElementById("venture-cart-drawer");
  if (!root) return;

  var els = {
    root: root,
    overlay: root.querySelector("[data-vcd-close].vcd__overlay") || root.querySelector(".vcd__overlay"),
    items: root.querySelector("[data-vcd-items]"),
    empty: root.querySelector("[data-vcd-empty]"),
    footer: root.querySelector("[data-vcd-footer]"),
    count: root.querySelector("[data-vcd-count]"),
    subtotal: root.querySelector("[data-vcd-subtotal]"),
    rewards: root.querySelector("[data-vcd-rewards]"),
    checkout: root.querySelector("[data-vcd-checkout]"),

    upsellWrap: root.querySelector("[data-vcd-upsell]"),
    upsellLabel: root.querySelector("[data-vcd-upsell-label]"),
    upsellList: root.querySelector("[data-vcd-upsell-list]"),
    upsellPrev: root.querySelector("[data-vcd-upsell-prev]"),
    upsellNext: root.querySelector("[data-vcd-upsell-next]"),

    trust: root.querySelector("[data-vcd-trust]")
  };

  var currentCart = null;

  // ---------------------------------------------------------
  // Money formatting
  // ---------------------------------------------------------
  function formatMoney(cents, currencyCode) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode || "GBP",
        currencyDisplay: "narrowSymbol"
      }).format(amount);
    } catch (e) {
      return (currencyCode || "") + " " + amount.toFixed(2);
    }
  }

  // ---------------------------------------------------------
  // Reward bar engine
  // ---------------------------------------------------------
  function calcSpendThreshold(reward, cart) {
    var threshold;
    if (window.Shopify && window.Shopify.country) {
      // Live path: derive the right GBP baseline from the shopper's
      // country (matching your real Shopify shipping zones), then
      // convert with Shopify's own live exchange rate.
      threshold = Math.round(ventureFreeShippingThresholdGBP() * ventureLiveFxRate());
    } else {
      // Fallback: window.Shopify isn't available for some reason —
      // use the static per-currency table instead.
      threshold = reward.thresholds[cart.currency] != null
        ? reward.thresholds[cart.currency]
        : reward.thresholds.default;
    }

    var thresholdCents = threshold * 100;
    var total = cart.total_price; // cents, after cart-level discounts
    var unlocked = total >= thresholdCents;
    var percent = Math.min(100, Math.round((total / thresholdCents) * 100));

    var message;
    if (unlocked) {
      message = reward.unlockedMessage;
    } else {
      var remaining = formatMoney(thresholdCents - total, cart.currency);
      message = reward.lockedMessage.replace("{remaining}", "<strong>" + remaining + "</strong>");
    }

    return { unlocked: unlocked, percent: percent, message: message, segments: 0 };
  }

  function calcBogoQuantity(reward, cart) {
    var qty = 0;
    cart.items.forEach(function (item) {
      var excluded = reward.excludeProductTypes.indexOf(item.product_type) !== -1;
      if (!excluded) qty += item.quantity;
    });

    var bundle = reward.bundleSize;
    var remainderInBundle = qty % bundle;
    var freeUnlockedCount = Math.floor(qty / bundle);
    var unlocked = qty > 0 && remainderInBundle === 0;
    var remaining = unlocked ? 0 : bundle - remainderInBundle;

    // Percent fill within the CURRENT bundle in progress
    var percent = qty === 0 ? 0 : Math.round((remainderInBundle / bundle) * 100);
    if (unlocked) percent = 100;

    var message;
    if (freeUnlockedCount > 0) {
      message = reward.unlockedMessage.replace("{count}", freeUnlockedCount);
      if (!unlocked) {
        // mid-way through the NEXT bundle after already unlocking one
        message += " " + reward.lockedMessage.replace("{remaining}", "<strong>" + remaining + "</strong>");
      }
    } else {
      message = reward.lockedMessage.replace("{remaining}", "<strong>" + remaining + "</strong>");
    }

    return { unlocked: freeUnlockedCount > 0, percent: percent, message: message, segments: bundle };
  }

  function renderRewards(cart) {
    if (!els.rewards) return;
    els.rewards.innerHTML = CONFIG.rewards.map(function (reward) {
      var result;
      if (reward.type === "spend_threshold") {
        result = calcSpendThreshold(reward, cart);
      } else if (reward.type === "bogo_quantity") {
        result = calcBogoQuantity(reward, cart);
      } else {
        return "";
      }

      var segmentsHtml = "";
      if (result.segments > 1) {
        segmentsHtml = '<div class="vcd-reward__segments">' +
          new Array(result.segments).fill("<span></span>").join("") +
          "</div>";
      }

      // Message sits above a bar with a fixed circular icon badge at
      // the end (grey while locked, solid black once unlocked) —
      // matches the Qikify reference rather than a separate label row.
      return (
        '<div class="vcd-reward' + (result.unlocked ? " is-unlocked" : "") + '" data-vcd-reward="' + reward.id + '" aria-label="' + reward.label + '">' +
          '<div class="vcd-reward__message">' + result.message + "</div>" +
          '<div class="vcd-reward__bar-row">' +
            '<div class="vcd-reward__track">' +
              '<div class="vcd-reward__fill" style="width:' + result.percent + '%"></div>' +
              segmentsHtml +
            "</div>" +
            '<div class="vcd-reward__badge">' + reward.icon + "</div>" +
          "</div>" +
        "</div>"
      );
    }).join("");
  }

  // ---------------------------------------------------------
  // Cart items rendering
  // ---------------------------------------------------------
  function renderItems(cart) {
    if (cart.items.length === 0) {
      els.items.innerHTML = "";
      els.empty.hidden = false;
      els.footer.style.display = "none";
      return;
    }

    els.empty.hidden = true;
    els.footer.style.display = "";
    els.items.innerHTML = cart.items.map(function (item, index) {
      var image = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, "_120x$1$2") : "";
      var variantLine = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";

      return (
        '<li class="vcd-item" data-vcd-line="' + (index + 1) + '" data-vcd-key="' + item.key + '">' +
          '<img class="vcd-item__image" src="' + image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' +
          '<div class="vcd-item__info">' +
            '<a class="vcd-item__title" href="' + item.url + '">' + escapeHtml(item.product_title) + "</a>" +
            (variantLine ? '<p class="vcd-item__variant">' + escapeHtml(variantLine) + "</p>" : "") +
            '<div class="vcd-item__qty">' +
              '<button type="button" data-vcd-qty-minus aria-label="Decrease quantity">&minus;</button>' +
              "<span>" + item.quantity + "</span>" +
              '<button type="button" data-vcd-qty-plus aria-label="Increase quantity">+</button>' +
            "</div>" +
          "</div>" +
          '<div class="vcd-item__side">' +
            '<button type="button" class="vcd-item__remove" data-vcd-remove aria-label="Remove item">' +
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M2 4h12M6.5 4V2.5a1 1 0 011-1h1a1 1 0 011 1V4M3.5 4l.6 8.4a1 1 0 001 .9h5.8a1 1 0 001-.9L12.5 4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>' +
              "</svg>" +
            "</button>" +
            '<p class="vcd-item__price">' + formatMoney(item.final_line_price, cart.currency) + "</p>" +
          "</div>" +
        "</li>"
      );
    }).join("");
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str || "";
    return div.innerHTML;
  }

  // ---------------------------------------------------------
  // Upsell / best sellers
  // Sourced from window.VentureCartBestSellers, a static list
  // rendered server-side by venture-cart-drawer.liquid from a
  // best-selling collection — no fetch, no per-item-added refetch.
  // Whatever's already in the cart (by product, not variant) is
  // always filtered out.
  // ---------------------------------------------------------
  function renderUpsell(cart) {
    if (!CONFIG.upsell.enabled || !els.upsellWrap) return;

    if (cart.items.length === 0) {
      els.upsellWrap.hidden = true;
      return;
    }

    var bestSellers = window.VentureCartBestSellers || [];
    var cartProductIds = cart.items.map(function (i) { return i.product_id; });
    var products = bestSellers
      .filter(function (p) { return cartProductIds.indexOf(p.id) === -1; })
      .slice(0, CONFIG.upsell.maxProducts);

    if (products.length === 0) {
      els.upsellWrap.hidden = true;
      return;
    }

    els.upsellLabel.textContent = CONFIG.upsell.label;
    els.upsellWrap.hidden = false;

    els.upsellList.innerHTML = products.map(function (product) {
      return (
        '<div class="vcd-upsell-item">' +
          '<img class="vcd-upsell-item__image" src="' + product.image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' +
          '<div>' +
            '<p class="vcd-upsell-item__title">' + escapeHtml(product.title) + "</p>" +
            '<p class="vcd-upsell-item__price">' + product.priceFormatted + "</p>" +
          "</div>" +
          '<button type="button" class="vcd-upsell-item__add" data-vcd-upsell-add="' + product.variantId + '" ' + (product.available ? "" : "disabled") + '>' +
            (product.available ? CONFIG.upsell.buttonText : "Sold out") +
          "</button>" +
        "</div>"
      );
    }).join("");
  }

  function scrollUpsell(direction) {
    if (!els.upsellList) return;
    var card = els.upsellList.querySelector(".vcd-upsell-item");
    var amount = card ? card.getBoundingClientRect().width + 12 : els.upsellList.clientWidth;
    els.upsellList.scrollBy({ left: direction * amount, behavior: "smooth" });
  }

  // ---------------------------------------------------------
  // Trust badges
  // ---------------------------------------------------------
  function renderTrustBadges() {
    if (!CONFIG.trustBadges.enabled || !els.trust) return;
    if (!CONFIG.trustBadges.icons.length) {
      els.trust.hidden = true;
      return;
    }
    els.trust.hidden = false;
    els.trust.innerHTML = CONFIG.trustBadges.icons.map(function (icon) {
      return '<img src="' + icon.src + '" alt="' + escapeHtml(icon.alt || "") + '" loading="lazy">';
    }).join("");
  }

  // ---------------------------------------------------------
  // Full render
  // ---------------------------------------------------------
  function render(cart) {
    currentCart = cart;
    els.count.textContent = cart.item_count;
    els.subtotal.textContent = formatMoney(cart.total_price, cart.currency);
    renderRewards(cart);
    renderItems(cart);
    renderUpsell(cart);
      }

  // ---------------------------------------------------------
  // Cart API calls
  // ---------------------------------------------------------
  function fetchCart() {
    return fetch("/cart.js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function refresh() {
    return fetchCart().then(render);
  }

  // ---------------------------------------------------------
  // Open / close
  // ---------------------------------------------------------
  function openDrawer() {
    els.root.classList.add("is-open");
    els.root.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    refresh();
  }

  function closeDrawer() {
    els.root.classList.remove("is-open");
    els.root.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  window.VentureCart = { open: openDrawer, close: closeDrawer, refresh: refresh };

  // ---------------------------------------------------------
  // Event delegation
  // ---------------------------------------------------------
  document.addEventListener("click", function (e) {
    var closeTarget = e.target.closest("[data-vcd-close]");
    if (closeTarget) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var openTarget = e.target.closest(CONFIG.openTriggerSelectors.join(","));
    if (openTarget) {
      e.preventDefault();
      openDrawer();
      return;
    }

    var minusBtn = e.target.closest("[data-vcd-qty-minus]");
    var plusBtn = e.target.closest("[data-vcd-qty-plus]");
    var removeBtn = e.target.closest("[data-vcd-remove]");

    if (minusBtn || plusBtn || removeBtn) {
      var li = e.target.closest("[data-vcd-key]");
      var key = li.getAttribute("data-vcd-key");
      var currentQty = parseInt(li.querySelector(".vcd-item__qty span").textContent, 10);
      var newQty = removeBtn ? 0 : (plusBtn ? currentQty + 1 : currentQty - 1);
      changeLine(key, newQty).then(render);
      return;
    }

    var upsellAddBtn = e.target.closest("[data-vcd-upsell-add]");
    if (upsellAddBtn && !upsellAddBtn.disabled) {
      var variantId = upsellAddBtn.getAttribute("data-vcd-upsell-add");
      upsellAddBtn.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(refresh);
      return;
    }

    if (els.upsellPrev && e.target.closest("[data-vcd-upsell-prev]")) {
      scrollUpsell(-1);
      return;
    }

    if (els.upsellNext && e.target.closest("[data-vcd-upsell-next]")) {
      scrollUpsell(1);
      return;
    }

  });

  // Escape key closes drawer
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  // ---------------------------------------------------------
  // Intercept native add-to-cart forms so the drawer opens
  // automatically, wherever those forms live in the theme.
  // ---------------------------------------------------------
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form.tagName === "FORM" && form.action && form.action.indexOf("/cart/add") !== -1)) return;

    e.preventDefault();
    var formData = new FormData(form);

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (CONFIG.autoOpenOnAdd) {
          openDrawer();
        } else {
          refresh();
        }
      })
      .catch(function (err) {
        console.error("Venture cart add failed", err);
        form.submit(); // fall back to normal page behaviour
      });
  });

  // One-time setup for sections that don't depend on cart contents
  renderTrustBadges();

  // Initial silent fetch so the count badge is correct on page load
  fetchCart().then(render);
})();
